import { create } from 'zustand'

export interface DiceFormula {
  count: number
  sides: number
  modifier: number
  raw: string
}

/** Parse "2d6", "1d20+3", "1d100" → structured formula (defaults to 1d20). */
export function parseFormula(raw: string): DiceFormula {
  const m = /(\d+)?\s*d\s*(\d+)\s*([+-]\s*\d+)?/i.exec(raw || '')
  if (!m) return { count: 1, sides: 20, modifier: 0, raw: '1d20' }
  return {
    count: Math.min(8, Math.max(1, parseInt(m[1] || '1', 10))),
    sides: Math.max(2, parseInt(m[2], 10)),
    modifier: m[3] ? parseInt(m[3].replace(/\s/g, ''), 10) : 0,
    raw,
  }
}

export interface DiceRequest {
  id: string
  formula: DiceFormula
  label?: string
  /** Called once the dice settle, with the authoritative total. */
  onResolved?: (total: number) => void
}

interface DiceState {
  request: DiceRequest | null
  /** Roll dice; the 3D overlay animates and resolves with the total. */
  roll: (opts: { formula: string; label?: string; onResolved?: (total: number) => void }) => void
  clear: () => void
}

let seq = 0

export const useDiceStore = create<DiceState>((set) => ({
  request: null,
  roll: ({ formula, label, onResolved }) =>
    set({ request: { id: `roll-${++seq}`, formula: parseFormula(formula), label, onResolved } }),
  clear: () => set({ request: null }),
}))
